import { fromJS } from 'immutable';

import {
	FETCH_PATIENT_PROFILE,
	FETCH_PATIENT_PROFILE_SUCCESS,
	FETCH_PATIENT_PROFILE_ERROR,
	FETCH_PATIENT_CALENDAR,
	FETCH_PATIENT_CALENDAR_SUCCESS,
	FETCH_PATIENT_CALENDAR_ERROR,
	FETCH_PATIENT_GROUPS,
	FETCH_PATIENT_GROUPS_SUCCESS,
	FETCH_PATIENT_GROUPS_ERROR,
	FETCH_PATIENT_OQ,
	FETCH_PATIENT_OQ_SUCCESS,
	FETCH_PATIENT_OQ_ERROR,
} from './constants';

const initialState = fromJS({
	profile: null,
	profileLoading: false,
	calendarEvents: [],
	calendarLoading: false,
	groups: [],
	groupsLoading: false,
	oq: null,
	oqLoading: false,
});

function referrerPatientViewReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_PATIENT_PROFILE:
			return state.set('profileLoading', true).set('profile', null);
		case FETCH_PATIENT_PROFILE_SUCCESS:
			return state.set('profile', fromJS(action.data)).set('profileLoading', false);
		case FETCH_PATIENT_PROFILE_ERROR:
			return state.set('profileLoading', false);

		case FETCH_PATIENT_CALENDAR:
			return state.set('calendarLoading', true);
		case FETCH_PATIENT_CALENDAR_SUCCESS: {
			const events = Array.isArray(action.data) ? action.data : [];
			return state.set('calendarEvents', fromJS(events)).set('calendarLoading', false);
		}
		case FETCH_PATIENT_CALENDAR_ERROR:
			return state.set('calendarLoading', false);

		case FETCH_PATIENT_GROUPS:
			return state.set('groupsLoading', true);
		case FETCH_PATIENT_GROUPS_SUCCESS:
			return state.set('groups', fromJS(action.data.groups || [])).set('groupsLoading', false);
		case FETCH_PATIENT_GROUPS_ERROR:
			return state.set('groupsLoading', false);

		case FETCH_PATIENT_OQ:
			return state.set('oqLoading', true);
		case FETCH_PATIENT_OQ_SUCCESS:
			return state.set('oq', fromJS(action.data)).set('oqLoading', false);
		case FETCH_PATIENT_OQ_ERROR:
			return state.set('oqLoading', false);

		default:
			return state;
	}
}

export default referrerPatientViewReducer;
